import React from 'react';
import { Play, ArrowRight } from 'lucide-react';
import { mediaSplits } from '../mock';

const MediaSplits = () => {
  return (
    <section className="bg-white">
      {mediaSplits.map((m, idx) => (
        <div
          key={idx}
          className={`grid lg:grid-cols-2 ${idx % 2 === 1 ? 'lg:[&>*:first-child]:order-2' : ''}`}
        >
          <div className="relative aspect-[16/9] lg:aspect-auto">
            <img src={m.image} alt={m.title} className="w-full h-full object-cover" />
            {m.duration && (
              <button className="absolute bottom-6 left-6 flex items-center gap-3 bg-black/60 hover:bg-black/80 text-white px-4 py-2 backdrop-blur-sm transition-colors">
                <Play className="w-4 h-4 fill-white" />
                <span className="text-sm font-medium">{m.duration}</span>
              </button>
            )}
          </div>
          <div className="bg-[#f4f7fb] flex items-center px-6 lg:px-16 py-12 lg:py-20">
            <div className="max-w-xl">
              <h3 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-[#0d274d] mb-5 leading-snug">{m.title}</h3>
              <p className="text-gray-700 text-base md:text-lg leading-relaxed mb-6">{m.description}</p>
              <a href="#" className="inline-flex items-center gap-2 text-[#0d274d] font-semibold border-b-2 border-[#00bceb] pb-1 hover:text-[#00bceb]">
                {m.cta}
                <ArrowRight className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>
      ))}
    </section>
  );
};

export default MediaSplits;
